<template>
    <el-dialog
        class="commom_dialog"
        :class="{ special_dialog: isSpecial }"
        :title="title"
        :visible.sync="visible"
        :width="width"
        :before-close="handleClose"
        :top="marginTop"
        :modal="modal"
        :show-close="showClose"
        :append-to-body="appendBody"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        v-bind="$attrs"
    >
        <div v-if="showSearch" class="search_box">
            <el-input
                v-model="search_text"
                placeholder="Search"
                class="search_input"
                @input="search"
                @keyup.enter.native="search"
            >
                <el-button
                    slot="append"
                    class="search_btn"
                    icon="el-icon-search"
                    @click="search"
                />
            </el-input>
        </div>
        <slot />
        <!-- <div v-else>
    <slot name="viewTop"></slot>
    <slot name="viewBottom"></slot>
  </div> -->
    </el-dialog>
</template>
<script>
export default {
    name: 'CommonDialog',
    props: {
        from: {
            type: String,
            default: ''
        },
        marginTop: {
            type: String,
            default: '25vh'
        },
        modal: {
            type: Boolean,
            default: true
        },
        showClose: {
            type: Boolean,
            default: true
        },
        width: {
            type: String,
            default: '480px'
        },
        title: {
            type: String,
            default: ''
        },
        dialogVisible: {
            type: Boolean,
            default: false
        },
        showSearch: {
            type: Boolean,
            default: false
        },
        appendBody: {
            type: Boolean,
            default: false
        },
        isSpecial: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visible: false,
            search_text: ''
        };
    },
    watch: {
        dialogVisible: {
            handler(val) {
                this.visible = val;
            },
            immediate: true
        },
        visible(val) {
            this.$emit('update:dialogVisible', val);
        }
    },
    created() {
        this.visible = this.dialogVisible;
    },
    methods: {
        handleClose() {
            this.search_text = '';
            this.$emit('handleClose', this.from);
        },
        search() {
            this.$emit('search', {
                from: this.from,
                keyword: this.search_text
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.commom_dialog {
    ::v-deep .el-dialog {
        background-color: #2b3139;
        border-radius: 15px;
    }

    ::v-deep .el-dialog__header {
        padding: 33px 26px 0 25px;
    }

    ::v-deep .el-dialog__body {
        padding: 0;
        // padding-top: 20px;
    }

    ::v-deep .el-dialog__title {
        font-size: 20px;
        font-family: PingFang_Regular;
        font-weight: 400;
        color: $basicWhite;
    }

    ::v-deep .el-dialog__headerbtn {
        font-size: 22px;
        top: 30px;
    }

    ::v-deep .el-dialog__close {
        color: #636b75;
        font-weight: bold;
    }

    ::v-deep .el-input__inner {
        height: 43px;
    }

    ::v-deep .el-button {
        height: 45px;
        background-color: $basicColor;
        font-size: 12px;
        color: #2b3139;

        & > span {
            font-family: PingFang_Regular;
        }
    }

    .search_box {
        padding-top: 20px;
        text-align: center;
        margin-bottom: 1px;
    }

    .search_input {
        width: 432px;
        height: 41px;
        border: 1px solid #474d57;
        border-radius: 21px;

        ::v-deep .el-input__inner {
            border-radius: 21px 21px 21px 21px;
            background-color: transparent;
            border: none;
            border-color: #474d57;
        }

        ::v-deep .el-input-group__append {
            border: 0;
            border-color: #474d57;
            background-color: transparent;
        }

        .el-button {
            color: #b7bdc6;
            background-color: transparent;
            font-size: 16px;
        }
    }
}

.special_dialog {
    .search_box {
        padding: 20px 40px 0;

        .search_input {
            width: 100%;
            border-radius: 8px;

            ::v-deep {
                .el-input__inner {
                    padding: 0 20px;
                    height: 39px;

                    &::placeholder {
                        color: #636b75;
                        font-size: 12px;
                    }
                }
            }
        }
    }

    ::v-deep {
        .el-dialog__header {
            padding: 21px 26px 0 !important;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .el-dialog__title {
                font-family: PingFang_Bold;
                font-weight: 600;
            }

            .el-dialog__headerbtn {
                position: static;
            }
        }
    }
}
</style>
